import { routes } from "@/routes/routes";
import { RouteName } from "@/routes/routes.types";

export const routeNames = Object.keys(routes) as RouteName[];
